// extracted by mini-css-extract-plugin
module.exports = {"form":"AwardedCouponForm_form__3Akut"};